import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getProvince,
  getParticularPage,
  getNext,
  getPrevious,
  createProvince,
  updateProvince,
  handleSearch,
} from "./thunk";

const initialState = {
  provinces: [],
  edit: false,
  province: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingProvince: false,
  loadingNext: false,
  showCreateModal: false,
};

export const provinceSlice = createSlice({
  name: "province",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    provinceEditSuccess: (state, action) => {
      state.edit = true;
      state.province = state.provinces.find((province) => province.id === action.payload);
    },
    clearAllProvince: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingProvince = false;
      state.province = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createProvince.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createProvince.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createProvince.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateProvince.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateProvince.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateProvince.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getProvince.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingProvince = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getProvince.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingProvince = false;
        state.provinces = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getProvince.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingProvince = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, provinceEditSuccess, clearAllProvince } = provinceSlice.actions;

export default provinceSlice.reducer;
